import React from "react"
import { StaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

/*
 * This component is built using `gatsby-image` to automatically serve optimized
 * images with lazy loading and reduced file sizes. The image is loaded using a
 * `StaticQuery`, which allows us to load the image from directly within this
 * component, rather than having to pass the image data down from pages.
 *
 * For more information, see the docs:
 * - `gatsby-image`: https://gatsby.dev/gatsby-image
 * - `StaticQuery`: https://gatsby.dev/staticquery
 */

const ImgYear19 = (props) => (
  <StaticQuery
    query={graphql`
      query {

        p1: file(relativePath: { eq: "studio/year19/1.jpg" }) {
          childImageSharp {
            fluid(quality: 50) {
              ...GatsbyImageSharpFluid
            }
          }
        }

        p2: file(relativePath: { eq: "studio/year19/2.jpg" }) {
            childImageSharp {
              fluid(quality: 50) {
                ...GatsbyImageSharpFluid
              }
            }
          }

          p3: file(relativePath: { eq: "studio/year19/3.jpg" }) {
            childImageSharp {
              fluid(quality: 50) {
                ...GatsbyImageSharpFluid
              }
            }
          }

          p4: file(relativePath: { eq: "studio/year19/4.jpg" }) {
            childImageSharp {
              fluid(quality: 50) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          p5: file(relativePath: { eq: "studio/year19/5.jpg" }) {
            childImageSharp {
              fluid(quality: 50) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          p6: file(relativePath: { eq: "studio/year19/6.jpg" }) {
            childImageSharp {
              fluid( quality: 50) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          p7: file(relativePath: { eq: "studio/year19/7.jpg" }) {
            childImageSharp {
              fluid(quality: 50) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          p8: file(relativePath: { eq: "studio/year19/8.jpg" }) {
            childImageSharp {
              fluid( quality: 50) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          p9: file(relativePath: { eq: "studio/year19/9.jpg" }) {
            childImageSharp {
              fluid( quality: 50) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          p10: file(relativePath: { eq: "studio/year19/10.jpg" }) {
            childImageSharp {
              fluid( quality: 50) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          p11: file(relativePath: { eq: "studio/year19/11.jpg" }) {
            childImageSharp {
              fluid( quality: 50) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          p12: file(relativePath: { eq: "studio/year19/12.jpg" }) {
            childImageSharp {
              fluid( quality: 50) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          p13: file(relativePath: { eq: "studio/year19/13.jpg" }) {
            childImageSharp {
              fluid( quality: 50) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          p14: file(relativePath: { eq: "studio/year19/14.jpg" }) {
            childImageSharp {
              fluid(quality: 50) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          p15: file(relativePath: { eq: "studio/year19/15.jpg" }) {
            childImageSharp {
              fluid( quality: 50) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          p16: file(relativePath: { eq: "studio/year19/16.jpg" }) {
            childImageSharp {
              fluid(quality: 50) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          p17: file(relativePath: { eq: "studio/year19/17.jpg" }) {
            childImageSharp {
              fluid(quality: 50) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          p18: file(relativePath: { eq: "studio/year19/18.jpg" }) {
            childImageSharp {
              fluid( quality: 50) {
                ...GatsbyImageSharpFluid
              }
            }
          }


          p19: file(relativePath: { eq: "studio/year19/19.jpg" }) {
            childImageSharp {
              fluid(quality: 50) {
                ...GatsbyImageSharpFluid
              }
            }
          }
  
          p20: file(relativePath: { eq: "studio/year19/20.jpg" }) {
              childImageSharp {
                fluid(quality: 50) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
  
            p21: file(relativePath: { eq: "studio/year19/21.jpg" }) {
              childImageSharp {
                fluid(quality: 50) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
  
            p22: file(relativePath: { eq: "studio/year19/22.jpg" }) {
              childImageSharp {
                fluid(quality: 50) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
            p23: file(relativePath: { eq: "studio/year19/23.jpg" }) {
              childImageSharp {
                fluid(quality: 50) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
            p24: file(relativePath: { eq: "studio/year19/24.jpg" }) {
              childImageSharp {
                fluid( quality: 50) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
            p25: file(relativePath: { eq: "studio/year19/25.jpg" }) {
              childImageSharp {
                fluid(quality: 50) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
            p26: file(relativePath: { eq: "studio/year19/26.jpg" }) {
              childImageSharp {
                fluid( quality: 50) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
            p27: file(relativePath: { eq: "studio/year19/27.jpg" }) {
              childImageSharp {
                fluid( quality: 50) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
            p28: file(relativePath: { eq: "studio/year19/28.jpg" }) {
              childImageSharp {
                fluid( quality: 50) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
            p29: file(relativePath: { eq: "studio/year19/29.jpg" }) {
              childImageSharp {
                fluid( quality: 50) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
            p30: file(relativePath: { eq: "studio/year19/30.jpg" }) {
              childImageSharp {
                fluid( quality: 50) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
            p31: file(relativePath: { eq: "studio/year19/31.jpg" }) {
              childImageSharp {
                fluid( quality: 50) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
            p32: file(relativePath: { eq: "studio/year19/32.jpg" }) {
              childImageSharp {
                fluid(quality: 50) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
            p33: file(relativePath: { eq: "studio/year19/33.jpg" }) {
              childImageSharp {
                fluid( quality: 50) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
            p34: file(relativePath: { eq: "studio/year19/34.jpg" }) {
              childImageSharp {
                fluid(quality: 50) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
            p35: file(relativePath: { eq: "studio/year19/35.jpg" }) {
              childImageSharp {
                fluid(quality: 50) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
            p36: file(relativePath: { eq: "studio/year19/36.jpg" }) {
              childImageSharp {
                fluid( quality: 50) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
            p37: file(relativePath: { eq: "studio/year19/37.jpg" }) {
                childImageSharp {
                  fluid( quality: 50) {
                    ...GatsbyImageSharpFluid
                  }
                }
              }
              p38: file(relativePath: { eq: "studio/year19/38.jpg" }) {
                childImageSharp {
                  fluid( quality: 50) {
                    ...GatsbyImageSharpFluid
                  }
                }
              }
              p39: file(relativePath: { eq: "studio/year19/39.jpg" }) {
                childImageSharp {
                  fluid(quality: 50) {
                    ...GatsbyImageSharpFluid
                  }
                }
              }
              p40: file(relativePath: { eq: "studio/year19/40.jpg" }) {
                childImageSharp {
                  fluid( quality: 50) {
                    ...GatsbyImageSharpFluid
                  }
                }
              }
              p41: file(relativePath: { eq: "studio/year19/41.jpg" }) {
                childImageSharp {
                  fluid(quality: 50) {
                    ...GatsbyImageSharpFluid
                  }
                }
              }
              p42: file(relativePath: { eq: "studio/year19/42.jpg" }) {
                childImageSharp {
                  fluid(quality: 50) {
                    ...GatsbyImageSharpFluid
                  }
                }
              }
              p43: file(relativePath: { eq: "studio/year19/43.jpg" }) {
                childImageSharp {
                  fluid(quality: 50) {
                    ...GatsbyImageSharpFluid
                  }
                }
              }
      
              p44: file(relativePath: { eq: "studio/year19/44.jpg" }) {
                  childImageSharp {
                    fluid(quality: 50) {
                      ...GatsbyImageSharpFluid
                    }
                  }
                }
      
                p45: file(relativePath: { eq: "studio/year19/45.jpg" }) {
                  childImageSharp {
                    fluid(quality: 50) {
                      ...GatsbyImageSharpFluid
                    }
                  }
                }
      
                p46: file(relativePath: { eq: "studio/year19/46.jpg" }) {
                  childImageSharp {
                    fluid(quality: 50) {
                      ...GatsbyImageSharpFluid
                    }
                  }
                }
                p47: file(relativePath: { eq: "studio/year19/47.jpg" }) {
                  childImageSharp {
                    fluid(quality: 50) {
                      ...GatsbyImageSharpFluid
                    }
                  }
                }
                p48: file(relativePath: { eq: "studio/year19/48.jpg" }) {
                  childImageSharp {
                    fluid( quality: 50) {
                      ...GatsbyImageSharpFluid
                    }
                  }
                }
                p49: file(relativePath: { eq: "studio/year19/49.jpg" }) {
                  childImageSharp {
                    fluid(quality: 50) {
                      ...GatsbyImageSharpFluid
                    }
                  }
                }
                p50: file(relativePath: { eq: "studio/year19/50.jpg" }) {
                  childImageSharp {
                    fluid( quality: 50) {
                      ...GatsbyImageSharpFluid
                    }
                  }
                }
                p51: file(relativePath: { eq: "studio/year19/51.jpg" }) {
                  childImageSharp {
                    fluid( quality: 50) {
                      ...GatsbyImageSharpFluid
                    }
                  }
                }
                p52: file(relativePath: { eq: "studio/year19/52.jpg" }) {
                  childImageSharp {
                    fluid( quality: 50) {
                      ...GatsbyImageSharpFluid
                    }
                  }
                }
                p53: file(relativePath: { eq: "studio/year19/53.jpg" }) {
                  childImageSharp {
                    fluid( quality: 50) {
                      ...GatsbyImageSharpFluid
                    }
                  }
                }
                p54: file(relativePath: { eq: "studio/year19/54.jpg" }) {
                  childImageSharp {
                    fluid( quality: 50) {
                      ...GatsbyImageSharpFluid
                    }
                  }
                }
                p55: file(relativePath: { eq: "studio/year19/55.jpg" }) {
                  childImageSharp {
                    fluid( quality: 50) {
                      ...GatsbyImageSharpFluid
                    }
                  }
                }
                p55: file(relativePath: { eq: "studio/year19/55.jpg" }) {
                  childImageSharp {
                    fluid(quality: 50) {
                      ...GatsbyImageSharpFluid
                    }
                  }
                }
                p56: file(relativePath: { eq: "studio/year19/56.jpg" }) {
                  childImageSharp {
                    fluid( quality: 50) {
                      ...GatsbyImageSharpFluid
                    }
                  }
                }
                p57: file(relativePath: { eq: "studio/year19/57.jpg" }) {
                  childImageSharp {
                    fluid(quality: 50) {
                      ...GatsbyImageSharpFluid
                    }
                  }
                }
                p58: file(relativePath: { eq: "studio/year19/58.jpg" }) {
                  childImageSharp {
                    fluid(quality: 50) {
                      ...GatsbyImageSharpFluid
                    }
                  }
                }
                p59: file(relativePath: { eq: "studio/year19/59.jpg" }) {
                  childImageSharp {
                    fluid( quality: 50) {
                      ...GatsbyImageSharpFluid
                    }
                  }
                }
      
      
                p60: file(relativePath: { eq: "studio/year19/60.jpg" }) {
                  childImageSharp {
                    fluid(quality: 50) {
                      ...GatsbyImageSharpFluid
                    }
                  }
                }
        
                  p61: file(relativePath: { eq: "studio/year19/61.jpg" }) {
                    childImageSharp {
                      fluid(quality: 50) {
                        ...GatsbyImageSharpFluid
                      }
                    }
                  }
        
                  p62: file(relativePath: { eq: "studio/year19/62.jpg" }) {
                    childImageSharp {
                      fluid(quality: 50) {
                        ...GatsbyImageSharpFluid
                      }
                    }
                  }
                  p63: file(relativePath: { eq: "studio/year19/63.jpg" }) {
                    childImageSharp {
                      fluid(quality: 50) {
                        ...GatsbyImageSharpFluid
                      }
                    }
                  }
                  p64: file(relativePath: { eq: "studio/year19/64.jpg" }) {
                    childImageSharp {
                      fluid( quality: 50) {
                        ...GatsbyImageSharpFluid
                      }
                    }
                  }
                  p65: file(relativePath: { eq: "studio/year19/65.jpg" }) {
                    childImageSharp {
                      fluid(quality: 50) {
                        ...GatsbyImageSharpFluid
                      }
                    }
                  }
                  p66: file(relativePath: { eq: "studio/year19/66.jpg" }) {
                    childImageSharp {
                      fluid( quality: 50) {
                        ...GatsbyImageSharpFluid
                      }
                    }
                  }
                  p67: file(relativePath: { eq: "studio/year19/67.jpg" }) {
                    childImageSharp {
                      fluid( quality: 50) {
                        ...GatsbyImageSharpFluid
                      }
                    }
                  }
                  p68: file(relativePath: { eq: "studio/year19/68.jpg" }) {
                    childImageSharp {
                      fluid( quality: 50) {
                        ...GatsbyImageSharpFluid
                      }
                    }
                  }
                  p69: file(relativePath: { eq: "studio/year19/69.jpg" }) {
                    childImageSharp {
                      fluid( quality: 50) {
                        ...GatsbyImageSharpFluid
                      }
                    }
                  }
                  p70: file(relativePath: { eq: "studio/year19/70.jpg" }) {
                    childImageSharp {
                      fluid( quality: 50) {
                        ...GatsbyImageSharpFluid
                      }
                    }
                  }
                  p71: file(relativePath: { eq: "studio/year19/71.jpg" }) {
                    childImageSharp {
                      fluid( quality: 50) {
                        ...GatsbyImageSharpFluid
                      }
                    }
                  }
                  p72: file(relativePath: { eq: "studio/year19/72.jpg" }) {
                    childImageSharp {
                      fluid(quality: 50) {
                        ...GatsbyImageSharpFluid
                      }
                    }
                  }
                  p73: file(relativePath: { eq: "studio/year19/73.jpg" }) {
                    childImageSharp {
                      fluid( quality: 50) {
                        ...GatsbyImageSharpFluid
                      }
                    }
                  }
                  p74: file(relativePath: { eq: "studio/year19/74.jpg" }) {
                    childImageSharp {
                      fluid(quality: 50) {
                        ...GatsbyImageSharpFluid
                      }
                    }
                  }
                  p75: file(relativePath: { eq: "studio/year19/75.jpg" }) {
                    childImageSharp {
                      fluid(quality: 50) {
                        ...GatsbyImageSharpFluid
                      }
                    }
                  }
                  p76: file(relativePath: { eq: "studio/year19/76.jpg" }) {
                    childImageSharp {
                      fluid( quality: 50) {
                        ...GatsbyImageSharpFluid
                      }
                    }
                  }
                  p77: file(relativePath: { eq: "studio/year19/77.jpg" }) {
                      childImageSharp {
                        fluid( quality: 50) {
                          ...GatsbyImageSharpFluid
                        }
                      }
                    }
                    p78: file(relativePath: { eq: "studio/year19/78.jpg" }) {
                      childImageSharp {
                        fluid( quality: 50) {
                          ...GatsbyImageSharpFluid
                        }
                      }
                    }
                    p79: file(relativePath: { eq: "studio/year19/79.jpg" }) {
                      childImageSharp {
                        fluid(quality: 50) {
                          ...GatsbyImageSharpFluid
                        }
                      }
                    }
                    p80: file(relativePath: { eq: "studio/year19/80.jpg" }) {
                      childImageSharp {
                        fluid( quality: 50) {
                          ...GatsbyImageSharpFluid
                        }
                      }
                    }
                    p81: file(relativePath: { eq: "studio/year19/81.jpg" }) {
                      childImageSharp {
                        fluid(quality: 50) {
                          ...GatsbyImageSharpFluid
                        }
                      }
                    }
                    p82: file(relativePath: { eq: "studio/year19/82.jpg" }) {
                      childImageSharp {
                        fluid(quality: 50) {
                          ...GatsbyImageSharpFluid
                        }
                      }
                    }
              
                        p83: file(relativePath: { eq: "studio/year19/83.jpg" }) {
                          childImageSharp {
                            fluid(quality: 50) {
                              ...GatsbyImageSharpFluid
                            }
                          }
                        }
              
                        p84: file(relativePath: { eq: "studio/year19/84.jpg" }) {
                          childImageSharp {
                            fluid(quality: 50) {
                              ...GatsbyImageSharpFluid
                            }
                          }
                        }
                        p85: file(relativePath: { eq: "studio/year19/85.jpg" }) {
                          childImageSharp {
                            fluid(quality: 50) {
                              ...GatsbyImageSharpFluid
                            }
                          }
                        }
                        p86: file(relativePath: { eq: "studio/year19/86.jpg" }) {
                          childImageSharp {
                            fluid( quality: 50) {
                              ...GatsbyImageSharpFluid
                            }
                          }
                        }
                        p87: file(relativePath: { eq: "studio/year19/87.jpg" }) {
                          childImageSharp {
                            fluid(quality: 50) {
                              ...GatsbyImageSharpFluid
                            }
                          }
                        }
                        p88: file(relativePath: { eq: "studio/year19/88.jpg" }) {
                          childImageSharp {
                            fluid( quality: 50) {
                              ...GatsbyImageSharpFluid
                            }
                          }
                        }
                        p89: file(relativePath: { eq: "studio/year19/89.jpg" }) {
                          childImageSharp {
                            fluid( quality: 50) {
                              ...GatsbyImageSharpFluid
                            }
                          }
                        }
                        p90: file(relativePath: { eq: "studio/year19/90.jpg" }) {
                          childImageSharp {
                            fluid( quality: 50) {
                              ...GatsbyImageSharpFluid
                            }
                          }
                        }
                        p91: file(relativePath: { eq: "studio/year19/91.jpg" }) {
                          childImageSharp {
                            fluid( quality: 50) {
                              ...GatsbyImageSharpFluid
                            }
                          }
                        }
                        p92: file(relativePath: { eq: "studio/year19/92.jpg" }) {
                          childImageSharp {
                            fluid( quality: 50) {
                              ...GatsbyImageSharpFluid
                            }
                          }
                        }
                        p93: file(relativePath: { eq: "studio/year19/93.jpg" }) {
                          childImageSharp {
                            fluid( quality: 50) {
                              ...GatsbyImageSharpFluid
                            }
                          }
                        }
                        p94: file(relativePath: { eq: "studio/year19/94.jpg" }) {
                          childImageSharp {
                            fluid(quality: 50) {
                              ...GatsbyImageSharpFluid
                            }
                          }
                        }
                        p95: file(relativePath: { eq: "studio/year19/95.jpg" }) {
                          childImageSharp {
                            fluid( quality: 50) {
                              ...GatsbyImageSharpFluid
                            }
                          }
                        }
                        p96: file(relativePath: { eq: "studio/year19/96.jpg" }) {
                          childImageSharp {
                            fluid(quality: 50) {
                              ...GatsbyImageSharpFluid
                            }
                          }
                        }
                        p97: file(relativePath: { eq: "studio/year19/97.jpg" }) {
                          childImageSharp {
                            fluid(quality: 50) {
                              ...GatsbyImageSharpFluid
                            }
                          }
                        }
                        p98: file(relativePath: { eq: "studio/year19/98.jpg" }) {
                          childImageSharp {
                            fluid( quality: 50) {
                              ...GatsbyImageSharpFluid
                            }
                          }
                        }
              
              
                        p99: file(relativePath: { eq: "studio/year19/99.jpg" }) {
                          childImageSharp {
                            fluid(quality: 50) {
                              ...GatsbyImageSharpFluid
                            }
                          }
                        }
                
                        p100: file(relativePath: { eq: "studio/year19/100.jpg" }) {
                            childImageSharp {
                              fluid(quality: 50) {
                                ...GatsbyImageSharpFluid
                              }
                            }
                          }
                
                          p101: file(relativePath: { eq: "studio/year19/101.jpg" }) {
                            childImageSharp {
                              fluid(quality: 50) {
                                ...GatsbyImageSharpFluid
                              }
                            }
                          }
                
                          p102: file(relativePath: { eq: "studio/year19/102.jpg" }) {
                            childImageSharp {
                              fluid(quality: 50) {
                                ...GatsbyImageSharpFluid
                              }
                            }
                          }
                          p103: file(relativePath: { eq: "studio/year19/103.jpg" }) {
                            childImageSharp {
                              fluid(quality: 50) {
                                ...GatsbyImageSharpFluid
                              }
                            }
                          }
                          p104: file(relativePath: { eq: "studio/year19/104.jpg" }) {
                            childImageSharp {
                              fluid( quality: 50) {
                                ...GatsbyImageSharpFluid
                              }
                            }
                          }
                          p105: file(relativePath: { eq: "studio/year19/105.jpg" }) {
                            childImageSharp {
                              fluid(quality: 50) {
                                ...GatsbyImageSharpFluid
                              }
                            }
                          }
                          p106: file(relativePath: { eq: "studio/year19/106.jpg" }) {
                            childImageSharp {
                              fluid( quality: 50) {
                                ...GatsbyImageSharpFluid
                              }
                            }
                          }
                          p107: file(relativePath: { eq: "studio/year19/107.jpg" }) {
                            childImageSharp {
                              fluid( quality: 50) {
                                ...GatsbyImageSharpFluid
                              }
                            }
                          }
                          p108: file(relativePath: { eq: "studio/year19/108.jpg" }) {
                            childImageSharp {
                              fluid( quality: 50) {
                                ...GatsbyImageSharpFluid
                              }
                            }
                          }
                          p109: file(relativePath: { eq: "studio/year19/109.jpg" }) {
                            childImageSharp {
                              fluid( quality: 50) {
                                ...GatsbyImageSharpFluid
                              }
                            }
                          }
                          p110: file(relativePath: { eq: "studio/year19/110.jpg" }) {
                            childImageSharp {
                              fluid( quality: 50) {
                                ...GatsbyImageSharpFluid
                              }
                            }
                          }
                          p111: file(relativePath: { eq: "studio/year19/111.jpg" }) {
                            childImageSharp {
                              fluid( quality: 50) {
                                ...GatsbyImageSharpFluid
                              }
                            }
                          }
                          p112: file(relativePath: { eq: "studio/year19/112.jpg" }) {
                            childImageSharp {
                              fluid(quality: 50) {
                                ...GatsbyImageSharpFluid
                              }
                            }
                          }
                          p113: file(relativePath: { eq: "studio/year19/113.jpg" }) {
                            childImageSharp {
                              fluid( quality: 50) {
                                ...GatsbyImageSharpFluid
                              }
                            }
                          }
                          p114: file(relativePath: { eq: "studio/year19/114.jpg" }) {
                            childImageSharp {
                              fluid(quality: 50) {
                                ...GatsbyImageSharpFluid
                              }
                            }
                          }
                          p115: file(relativePath: { eq: "studio/year19/115.jpg" }) {
                            childImageSharp {
                              fluid(quality: 50) {
                                ...GatsbyImageSharpFluid
                              }
                            }
                          }
                          p116: file(relativePath: { eq: "studio/year19/116.jpg" }) {
                            childImageSharp {
                              fluid( quality: 50) {
                                ...GatsbyImageSharpFluid
                              }
                            }
                          }
                          p117: file(relativePath: { eq: "studio/year19/117.jpg" }) {
                              childImageSharp {
                                fluid( quality: 50) {
                                  ...GatsbyImageSharpFluid
                                }
                              }
                            }
                            p118: file(relativePath: { eq: "studio/year19/118.jpg" }) {
                              childImageSharp {
                                fluid( quality: 50) {
                                  ...GatsbyImageSharpFluid
                                }
                              }
                            }
                            p119: file(relativePath: { eq: "studio/year19/119.jpg" }) {
                              childImageSharp {
                                fluid(quality: 50) {
                                  ...GatsbyImageSharpFluid
                                }
                              }
                            }
                            p120: file(relativePath: { eq: "studio/year19/120.jpg" }) {
                              childImageSharp {
                                fluid( quality: 50) {
                                  ...GatsbyImageSharpFluid
                                }
                              }
                            }
                            p121: file(relativePath: { eq: "studio/year19/121.jpg" }) {
                                childImageSharp {
                                  fluid( quality: 50) {
                                    ...GatsbyImageSharpFluid
                                  }
                                }
                              }
                              p122: file(relativePath: { eq: "studio/year19/122.jpg" }) {
                                childImageSharp {
                                  fluid(quality: 50) {
                                    ...GatsbyImageSharpFluid
                                  }
                                }
                              }
                              p123: file(relativePath: { eq: "studio/year19/123.jpg" }) {
                                childImageSharp {
                                  fluid( quality: 50) {
                                    ...GatsbyImageSharpFluid
                                  }
                                }
                              }
                              p124: file(relativePath: { eq: "studio/year19/124.jpg" }) {
                                childImageSharp {
                                  fluid(quality: 50) {
                                    ...GatsbyImageSharpFluid
                                  }
                                }
                              }
                             p125: file(relativePath: { eq: "studio/year19/125.jpg" }) {
                                childImageSharp {
                                  fluid(quality: 50) {
                                    ...GatsbyImageSharpFluid
                                  }
                                }
                              }
                              p126: file(relativePath: { eq: "studio/year19/126.jpg" }) {
                                childImageSharp {
                                  fluid(quality: 50) {
                                    ...GatsbyImageSharpFluid
                                  }
                                }
                              }
                              p127: file(relativePath: { eq: "studio/year19/127.jpg" }) {
                                childImageSharp {
                                  fluid(quality: 50) {
                                    ...GatsbyImageSharpFluid
                                  }
                                }
                              }
                              p128: file(relativePath: { eq: "studio/year19/128.jpg" }) {
                                childImageSharp {
                                  fluid(quality: 50) {
                                    ...GatsbyImageSharpFluid
                                  }
                                }
                              }
                              p129: file(relativePath: { eq: "studio/year19/129.jpg" }) {
                                childImageSharp {
                                  fluid(quality: 50) {
                                    ...GatsbyImageSharpFluid
                                  }
                                }
                              }
                              p130: file(relativePath: { eq: "studio/year19/130.jpg" }) {
                                childImageSharp {
                                  fluid(quality: 50) {
                                    ...GatsbyImageSharpFluid
                                  }
                                }
                              }
                              p131: file(relativePath: { eq: "studio/year19/131.jpg" }) {
                                childImageSharp {
                                  fluid(quality: 50) {
                                    ...GatsbyImageSharpFluid
                                  }
                                }
                              }
                              p132: file(relativePath: { eq: "studio/year19/132.jpg" }) {
                                childImageSharp {
                                  fluid(quality: 50) {
                                    ...GatsbyImageSharpFluid
                                  }
                                }
                              }
                              p133: file(relativePath: { eq: "studio/year19/133.jpg" }) {
                                childImageSharp {
                                  fluid(quality: 50) {
                                    ...GatsbyImageSharpFluid
                                  }
                                }
                              }
                              p134: file(relativePath: { eq: "studio/year19/134.jpg" }) {
                                childImageSharp {
                                  fluid(quality: 50) {
                                    ...GatsbyImageSharpFluid
                                  }
                                }
                              }
                              p135: file(relativePath: { eq: "studio/year19/135.jpg" }) {
                                childImageSharp {
                                  fluid(quality: 50) {
                                    ...GatsbyImageSharpFluid
                                  }
                                }
                              }
                              p136: file(relativePath: { eq: "studio/year19/136.jpg" }) {
                                childImageSharp {
                                  fluid(quality: 50) {
                                    ...GatsbyImageSharpFluid
                                  }
                                }
                              }
                              p137: file(relativePath: { eq: "studio/year19/137.jpg" }) {
                                childImageSharp {
                                  fluid(quality: 50) {
                                    ...GatsbyImageSharpFluid
                                  }
                                }
                              }
                              p138: file(relativePath: { eq: "studio/year19/138.jpg" }) {
                                childImageSharp {
                                  fluid(quality: 50) {
                                    ...GatsbyImageSharpFluid
                                  }
                                }
                              }
                              p139: file(relativePath: { eq: "studio/year19/139.jpg" }) {
                                childImageSharp {
                                  fluid(quality: 50) {
                                    ...GatsbyImageSharpFluid
                                  }
                                }
                              }
                              p140: file(relativePath: { eq: "studio/year19/140.jpg" }) {
                                childImageSharp {
                                  fluid(quality: 50) {
                                    ...GatsbyImageSharpFluid
                                  }
                                }
                              }
                              p141: file(relativePath: { eq: "studio/year19/141.jpg" }) {
                                childImageSharp {
                                  fluid(quality: 50) {
                                    ...GatsbyImageSharpFluid
                                  }
                                }
                              }
                              p142: file(relativePath: { eq: "studio/year19/142.jpg" }) {
                                childImageSharp {
                                  fluid(quality: 50) {
                                    ...GatsbyImageSharpFluid
                                  }
                                }
                              }
                              p143: file(relativePath: { eq: "studio/year19/143.jpg" }) {
                                childImageSharp {
                                  fluid(quality: 50) {
                                    ...GatsbyImageSharpFluid
                                  }
                                }
                              }

      }
    `}
    render={data => <Img fluid={data[props.image].childImageSharp.fluid} />}
  />
)
export default ImgYear19
